export function Checkbox() {
  return (
    <path
      fill="currentColor"
      d="M6 0C2.687 0 0 2.687 0 6v36c0 3.314 2.687 6 6 6h36c3.313 0 6-2.686 6-6V6c0-3.313-2.687-6-6-6H6zm36 2c2.206 0 4 1.794 4 4v36c0 2.206-1.794 4-4 4H6c-2.206 0-4-1.794-4-4V6c0-2.206 1.794-4 4-4h36"
    />
  )
}
